export const EMERGENCY_SERVICE_TYPES = [
  { value: "hospital", label: "Hospital", shortLabel: "Hospital", query: "hospital" },
  { value: "police", label: "Police", shortLabel: "Police", query: "police station" },
  { value: "fire_station", label: "Fire Station", shortLabel: "Fire", query: "fire station" },
  { value: "ems", label: "EMS", shortLabel: "EMS", query: "ems" },
  { value: "shelter", label: "Shelter", shortLabel: "Shelter", query: "shelter" },
  { value: "urgent_care", label: "Urgent Care", shortLabel: "Urgent Care", query: "urgent care" },
  { value: "pharmacy", label: "Pharmacy", shortLabel: "Pharmacy", query: "pharmacy" },
];

export const EMERGENCY_REPORT_TYPES = [
  { value: "medical", label: "Medical Emergency" },
  { value: "fire", label: "Fire / Smoke" },
  { value: "police", label: "Law Enforcement" },
  { value: "collision", label: "Vehicle Collision" },
  { value: "rollover", label: "Rollover / Major Crash" },
  { value: "hazmat", label: "Hazmat Spill / Leak" },
  { value: "cargo_theft", label: "Cargo Theft / Hijacking" },
  { value: "assault", label: "Assault / Violence" },
  { value: "road_hazard", label: "Road Hazard" },
  { value: "traffic_blockage", label: "Traffic Blockage" },
  { value: "weather", label: "Weather Impact" },
  { value: "flooding", label: "Flooding / Water Over Road" },
  { value: "power_outage", label: "Power / Signal Outage" },
  { value: "stranded_driver", label: "Stranded Driver" },
  { value: "shelter_request", label: "Shelter Request" },
  { value: "pharmacy_need", label: "Supply / Medication Need" },
  { value: "mechanical", label: "Mechanical Breakdown" },
  { value: "other", label: "Other" },
];

export const EMERGENCY_SERVICE_STATUSES = [
  { value: "active", label: "Active" },
  { value: "limited", label: "Limited" },
  { value: "busy", label: "Busy" },
  { value: "closed", label: "Closed" },
];

export const EMERGENCY_REPORT_STATUSES = [
  { value: "open", label: "Open" },
  { value: "acknowledged", label: "Acknowledged" },
  { value: "resolved", label: "Resolved" },
];

export const EMERGENCY_SEVERITIES = [
  { value: "advisory", label: "Advisory" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
  { value: "critical", label: "Critical" },
];

const serviceTypeMeta = {
  hospital: { label: "Hospital", color: "#ef4444", markerClass: "border-red-300 bg-red-600 text-white" },
  police: { label: "Police", color: "#2563eb", markerClass: "border-blue-300 bg-blue-600 text-white" },
  fire_station: { label: "Fire Station", color: "#f97316", markerClass: "border-orange-300 bg-orange-500 text-black" },
  ems: { label: "EMS", color: "#06b6d4", markerClass: "border-cyan-300 bg-cyan-500 text-black" },
  shelter: { label: "Shelter", color: "#a855f7", markerClass: "border-violet-300 bg-violet-500 text-white" },
  urgent_care: { label: "Urgent Care", color: "#10b981", markerClass: "border-emerald-300 bg-emerald-500 text-black" },
  pharmacy: { label: "Pharmacy", color: "#eab308", markerClass: "border-yellow-200 bg-yellow-400 text-black" },
};

const serviceStatusMeta = {
  active: {
    label: "Active",
    badgeClass: "border-emerald-500/40 bg-emerald-500/15 text-emerald-200",
  },
  limited: {
    label: "Limited",
    badgeClass: "border-amber-500/40 bg-amber-500/15 text-amber-100",
  },
  busy: {
    label: "Busy",
    badgeClass: "border-orange-500/40 bg-orange-500/15 text-orange-100",
  },
  closed: {
    label: "Closed",
    badgeClass: "border-stone-600 bg-stone-800/80 text-stone-200",
  },
};

const reportTypeMeta = {
  medical: { label: "Medical Emergency" },
  fire: { label: "Fire / Smoke" },
  police: { label: "Law Enforcement" },
  collision: { label: "Vehicle Collision" },
  rollover: { label: "Rollover / Major Crash" },
  hazmat: { label: "Hazmat Spill / Leak" },
  cargo_theft: { label: "Cargo Theft / Hijacking" },
  assault: { label: "Assault / Violence" },
  road_hazard: { label: "Road Hazard" },
  traffic_blockage: { label: "Traffic Blockage" },
  weather: { label: "Weather Impact" },
  flooding: { label: "Flooding / Water Over Road" },
  power_outage: { label: "Power / Signal Outage" },
  stranded_driver: { label: "Stranded Driver" },
  shelter_request: { label: "Shelter Request" },
  pharmacy_need: { label: "Supply / Medication Need" },
  mechanical: { label: "Mechanical Breakdown" },
  other: { label: "Other" },
};

const severityMeta = {
  advisory: {
    label: "Advisory",
    color: "#94a3b8",
    badgeClass: "border-slate-500/40 bg-slate-500/15 text-slate-100",
    markerClass: "border-slate-300 bg-slate-500 text-white",
  },
  low: {
    label: "Low",
    color: "#facc15",
    badgeClass: "border-yellow-500/40 bg-yellow-500/15 text-yellow-100",
    markerClass: "border-yellow-200 bg-yellow-400 text-black",
  },
  medium: {
    label: "Medium",
    color: "#fb923c",
    badgeClass: "border-orange-500/40 bg-orange-500/15 text-orange-100",
    markerClass: "border-orange-200 bg-orange-500 text-black",
  },
  high: {
    label: "High",
    color: "#ef4444",
    badgeClass: "border-red-500/40 bg-red-500/15 text-red-100",
    markerClass: "border-red-200 bg-red-600 text-white",
  },
  urgent: {
    label: "Urgent",
    color: "#dc2626",
    badgeClass: "border-rose-500/40 bg-rose-500/15 text-rose-100",
    markerClass: "border-rose-200 bg-rose-600 text-white",
  },
  critical: {
    label: "Critical",
    color: "#b91c1c",
    badgeClass: "border-rose-500/40 bg-rose-500/20 text-rose-100",
    markerClass: "border-rose-200 bg-rose-700 text-white",
  },
};

const reportStatusMeta = {
  open: { label: "Open", badgeClass: "border-red-500/40 bg-red-500/10 text-red-100" },
  acknowledged: { label: "Acknowledged", badgeClass: "border-orange-500/40 bg-orange-500/10 text-orange-100" },
  resolved: { label: "Resolved", badgeClass: "border-emerald-500/40 bg-emerald-500/10 text-emerald-100" },
};

const fallbackLabel = (value) =>
  String(value || "")
    .replaceAll("_", " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getEmergencyServiceTypeMeta = (value) => serviceTypeMeta[value] || { label: fallbackLabel(value), color: "#f97316", markerClass: "border-orange-200 bg-orange-500 text-black" };
export const getEmergencyServiceTypeLabel = (value) => getEmergencyServiceTypeMeta(value).label;
export const getEmergencyServiceColor = (value) => getEmergencyServiceTypeMeta(value).color;

export const getEmergencyServiceStatusMeta = (value) => serviceStatusMeta[value] || { label: fallbackLabel(value), badgeClass: "border-stone-600 bg-stone-800/80 text-stone-200" };
export const getEmergencyServiceStatusLabel = (value) => getEmergencyServiceStatusMeta(value).label;
export const getEmergencyServiceBadgeClass = (value) => getEmergencyServiceStatusMeta(value).badgeClass;

export const getEmergencyReportTypeLabel = (value) => (reportTypeMeta[value]?.label || fallbackLabel(value));
export const getEmergencySeverityMeta = (value) => severityMeta[value] || severityMeta.medium;
export const getEmergencySeverityLabel = (value) => getEmergencySeverityMeta(value).label;
export const getEmergencySeverityColor = (value) => getEmergencySeverityMeta(value).color;
export const getEmergencySeverityBadgeClass = (value) => getEmergencySeverityMeta(value).badgeClass;

export const getEmergencyReportStatusMeta = (value) => reportStatusMeta[value] || { label: fallbackLabel(value), badgeClass: "border-stone-600 bg-stone-800/80 text-stone-200" };
export const getEmergencyReportStatusLabel = (value) => getEmergencyReportStatusMeta(value).label;
export const getEmergencyReportStatusBadgeClass = (value) => getEmergencyReportStatusMeta(value).badgeClass;

export const getEmergencyServiceMarkerClass = (type, status = "active") => {
  const typeClass = getEmergencyServiceTypeMeta(type).markerClass;
  const mutedClass = status === "closed" ? "opacity-55 grayscale" : "";
  return `inline-flex h-9 w-9 items-center justify-center rounded-full border-2 shadow-[0_0_16px_rgba(0,0,0,0.35)] ${typeClass} ${mutedClass}`.trim();
};

export const getEmergencyReportMarkerClass = (severity, status = "open") => {
  const severityClass = getEmergencySeverityMeta(severity).markerClass;
  const resolvedClass = status === "resolved" ? "opacity-60 scale-90" : "";
  return `inline-flex h-7 w-7 items-center justify-center rounded-full border-2 shadow-[0_0_18px_rgba(239,68,68,0.35)] ${severityClass} ${resolvedClass}`.trim();
};

export const formatEmergencyCoordinates = (coords) => {
  const latitude = Number(coords?.latitude ?? coords?.lat);
  const longitude = Number(coords?.longitude ?? coords?.lng);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return "Coordinates pending";
  return `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`;
};

export const formatEmergencyDistance = (miles) => {
  const value = Number(miles);
  if (!Number.isFinite(value)) return "-";
  if (value < 0.1) return "< 0.1 mi";
  return `${value.toFixed(value >= 10 ? 0 : 1)} mi`;
};

export const formatEmergencyEta = (seconds) => {
  const total = Number(seconds);
  if (!Number.isFinite(total) || total <= 0) return "-";
  const hours = Math.floor(total / 3600);
  const minutes = Math.max(1, Math.round((total % 3600) / 60));
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};

export const getEmergencyRoutePreferenceLabel = (value) => {
  if (value === "nearest") return "Nearest";
  if (value === "fastest") return "Fastest";
  return fallbackLabel(value);
};
